import React from "react";
import moment from "moment";
import TableLoader from "../Loaders/TableLoader";

function TableBody({
  tableData,
  tableBodyList,
  handleRowClick = () => {},
  isLoadingData,
  checkIsLoadingData = false,
}) {
  const handleData = (data, item, index) => {
    if (item.handleCell) return item.handleCell(data, item, index);
    if (item.customRender) return item.customRender({ data, item, index });
    if (item.dateFormat)
      return data[item.name]
        ? moment(data[item.name]).format(item.dateFormat)
        : "";
    return data[item.name];
  };
  if (isLoadingData && tableData?.length === 0) {
    return (
      <tbody className="position-relative ">
        <tr>
          <td colSpan={tableBodyList?.length}>
            <TableLoader isLoading={true} />
          </td>
        </tr>
      </tbody>
    );
  }
  if (checkIsLoadingData && isLoadingData) {
    return (
      <tbody className="position-relative ">
        <tr>
          <td colSpan={tableBodyList?.length}>
            <TableLoader isLoading={true} />
          </td>
        </tr>
      </tbody>
    );
  }
  return (
    <tbody>
      {tableData?.length > 0 ? (
        tableData?.map((data, index) => (
          <tr key={data.id} onClick={() => handleRowClick(data, index)}>
            {tableBodyList.map((item) => (
              <td
                className="text-capitalize"
                key={`body-${item.title}-${index}`}
                style={{ ...item.style }}
              >
                {handleData(data, item, index)}
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={tableBodyList.length} className="text-center">
            No Data
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TableBody;
